import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import type { AlertProps } from '@ingenico/react-ui/core-alert';
import { CoreAlert } from '@ingenico/react-ui/core-alert';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type BannerProps = Omit<AlertProps, 'undoButtonLabel'>;

export function Banner(props: BannerProps): ReactElement {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.COMMON]);

  return <CoreAlert {...props} undoButtonLabel={t('button.undo', { ns: ALL_LNGS_NAMESPACES.COMMON })} />;
}
